import type { ProjectNode, ProjectPath, ProjectTree } from "../api/generated";

export interface ProjectRow {
  node: ProjectNode;
  depth: number;
}

export function visibleProjectRows(
  tree: ProjectTree,
  collapsed: ReadonlySet<string>,
): ProjectRow[] {
  const rows: ProjectRow[] = [];
  const visit = (nodes: ProjectNode[], depth: number) => {
    for (const node of nodes) {
      rows.push({ node, depth });
      if (!collapsed.has(pathKey(node.path))) visit(node.children, depth + 1);
    }
  };
  visit(tree.roots, 0);
  return rows;
}

export function allProjectPaths(tree: ProjectTree): ProjectPath[] {
  const paths: ProjectPath[] = [];
  const visit = (nodes: ProjectNode[]) => {
    for (const node of nodes) {
      paths.push(node.path);
      visit(node.children);
    }
  };
  visit(tree.roots);
  return paths;
}

export function pathKey(path: ProjectPath): string {
  return path.join("/");
}

/** Open tasks in the project and every subproject beneath it. */
export function subtreePendingCount(node: ProjectNode): number {
  return node.children.reduce(
    (total, child) => total + subtreePendingCount(child),
    node.pending_tasks,
  );
}
